import * as THREE from 'three';
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader';

// Taken fom AVA
export const loadSharedTexture = async (id, url) => {
  try {
    const loader = new THREE.TextureLoader();
    const texture = await new Promise((resolve, reject) => {
      loader.load(url, resolve, undefined, reject);
    });
    
    return {
      _id: id,
      texture: texture
    };
  } catch (error) {
    throw new Error(`Failed to load texture ${id}: ${error.message}`);
  }
};

export const applyLightMaps = async (model) => {
  const texturesMap = {}; //textures can be reused, no need to fetch multiple times

  model.traverse((object) => {
    if (object?.isMesh && object?.userData) {
      /*** GLTFExporter doesn't store/bake-in lightMap textures applied on UI editors, so we store it in userData ***/
      const { _lightMap } = object?.material?.userData;
      if (_lightMap) texturesMap[_lightMap._id] = { ..._lightMap };
    }
});

  const promises = await Promise.allSettled(
    Object.values(texturesMap).map(async (item) =>
      loadSharedTexture(item._id, item.url)
    )
  );
  promises.map((i) => {
    if (i.status === "fulfilled")
      texturesMap[i.value._id].texture = i.value.texture;
  });

  /*** Apply ***/
  model.traverse((object) => {
    if (object?.isMesh && object?.userData) {
      /*** GLTFExporter doesn't store/bake-in lightMap textures applied on UI editors, so we store base64 img in userData ***/
      const { _lightMap, lightMapIntensity } = object?.material?.userData;
      if (_lightMap) {
        if (texturesMap[_lightMap._id]) {
          const texture = texturesMap[_lightMap._id]?.texture;
          texture.channel = 1;
          object.material.lightMap = texture;
          if (typeof lightMapIntensity === "number" && lightMapIntensity >= 0)
            object.material.lightMapIntensity = lightMapIntensity;
          object.material.needsUpdate = true;
        }
      }
    }
  });
};

export const loadCubemapTexturesBitmap = (basePath, img_set) => {
	return new Promise((resolve, reject) => {
		const texture = new THREE.CubeTexture();

		const loader = new THREE.ImageBitmapLoader();
		loader.setPath(basePath);
		// loader.setCrossOrigin( this.crossOrigin );

		const loadAsync = (url) => {
			return new Promise((resolve, reject) => {
				loader.load(
					url,
					(imageBitmap) => {
						resolve(imageBitmap);
					},
					undefined,
					(err) => reject(err),
				);
			});
		};

		Promise.all(img_set.map((url) => loadAsync(url)))
			.then((imageBitmaps) => {
				texture.images = imageBitmaps;
				texture.needsUpdate = true;
				resolve(texture);
			})
			.catch((err) => reject(err));
	});
};

export const loadHDRImage = async (imageUrl, renderer) => {
	return new Promise((resolve, reject) => {
		const pmremGenerator = new THREE.PMREMGenerator(renderer);
		pmremGenerator.compileEquirectangularShader();

		new RGBELoader().load(
			imageUrl,
			(texture) => {
				const envMap =
					pmremGenerator.fromEquirectangular(texture).texture;

				resolve(envMap);

				pmremGenerator.dispose();
			},
			null,
			reject,
		);
	});
};

/***
 * cubemap - set of 6 images that builds scene.background or scene.environment
 * approaches: CubeTextureLoader, custom bitmap loader
 ***/
export const loadCubemapTextures = async (basePath, img_set, mode = '') => {
	if (mode === 'bitmap') {
		return loadCubemapTexturesBitmap(basePath, img_set);
	}
	//default threeJS cubemap loader
	else {
		return new Promise((resolve, reject) => {
			const loader = new THREE.CubeTextureLoader();
			loader.setPath(basePath);
			loader.load(img_set, resolve, null, reject);
		});
	}
};

export const getTextureKeys = (resolution, key, useWebp) => {
	const faces = ['back', 'front', 'top', 'bottom', 'right', 'left'];
	const ext = useWebp ? 'webp' : 'jpg';
	return faces.map((face) => `${resolution}_${face}.${ext}?key=${key}`);
};
